import React, { memo } from "react"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
import clsx from "clsx"
import Typography from "@material-ui/core/Typography"
import ParticipantCompleteProgressBar from "./ParticipantCompleteProgressBar"
import ParticipantDetailProgressDetail from "./ParticipantDetailProgressDetail"

const useStyles = makeStyles((theme) => ({
    topContentWrapper: {
        position: "relative",
        display: "flex",
        flexFlow: "wrap",
        width: "100%",
        flexDirection: "column",
        color: "#000000",
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
        },
        minHeight: "200px",
    },
    loading: {
        minHeight: "50vh",
    },
    roleWrapper: {
        flex: "0 0 50%",
        overflow: "hidden",
        position: "relative",
        flexDirection: "column",
        borderBottom: "1px solid #eeeeef",
        "&:nth-child(2n-1)": {
            borderRight: "1px solid #eeeeef",
        },
    },
    roleWrapperTop: {
        padding: theme.spacing(4, 3),
        minHeight: "230px",
        position: "relative",
        background: "linear-gradient(180deg,#bfbfc4 -3em,#f4f4f5 1em,#f4f4f5),#f4f4f5",
        [theme.breakpoints.up("md")]: {
            background: "none",
        },
    },
    roleName: {
        color: "#000000",
    },
    notificationText: {
        color: theme.palette.primary.main,
        fontStyle: "italic",
        fontWeight: "bold",
    },
    roleParticipantProgressBarWrapper: {
        padding: theme.spacing(4, 3),
        height: "100%",
        background: "none",
        [theme.breakpoints.up("md")]: {
            background: "linear-gradient(180deg,#bfbfc4 -3em,#f4f4f5 1em,#f4f4f5),#f4f4f5",
        },
    },
    roleProgressBarWrapper: {
        position: "absolute",
        width: "calc(100% - 30px)",
        bottom: "25px",
    },
    smallFont: {
        fontSize: "80%",
    },
}))

const TopContent = memo((props) => {
    const classes = useStyles()
    const { projectRolesRetrieve, participantHaveRolesGroupedByRole } = props

    return (
        <>
            {projectRolesRetrieve.projectRoles.length ? (
                <Box className={classes.topContentWrapper}>
                    {projectRolesRetrieve.projectRoles.map((projectRole) => (
                        <Box key={projectRole.roleId} className={classes.roleWrapper}>
                            <Box key={projectRole.roleId} className={classes.roleWrapperTop}>
                                <Box className={classes.roleNameWrapper} mb={4}>
                                    <Typography className={classes.roleName} variant="h6" component="h2">
                                        {projectRole.roleName}
                                    </Typography>
                                </Box>
                                <Box className={classes.roleNameWrapper} mb={2} style={{ display: "none" }}>
                                    <Typography>{projectRole.roleId}</Typography>
                                </Box>
                                <Box className={classes.roleShortDescriptionWrapper}>
                                    <Typography
                                        className={clsx(classes.smallFont, classes.roleShortDescription)}
                                        dangerouslySetInnerHTML={{ __html: projectRole.roleShortDescription }}
                                    />
                                </Box>
                                <Box mt={4}>
                                    <Typography component="p" className={classes.notificationText}>
                                        *Add a minimum of 3 respondents per role
                                    </Typography>
                                </Box>
                                <Box mt={4} className={classes.roleProgressBarWrapper}>
                                    {participantHaveRolesGroupedByRole ? (
                                        <ParticipantCompleteProgressBar
                                            participantHaveRolesGroupedByRole={participantHaveRolesGroupedByRole[projectRole.roleId]}
                                        />
                                    ) : (
                                        <Box>
                                            {/* <Typography>No Participants added yet</Typography> */}
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                            <Box className={classes.roleParticipantProgressBarWrapper}>
                                {participantHaveRolesGroupedByRole ? (
                                    <ParticipantDetailProgressDetail
                                        participantHaveRolesGroupedByRole={participantHaveRolesGroupedByRole[projectRole.roleId]}
                                    />
                                ) : (
                                    <Box>
                                        {/* <Typography>No Participants added yet</Typography> */}
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    ))}
                </Box>
            ) : null}
        </>
    )
})

export default TopContent
